'use client';

import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

type MultiStepContextValues = {
  currentStep: number;
  totalOfSteps: number;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  setTotalOfSteps: Dispatch<SetStateAction<number>>;
};

const multiStepIndicatorInitialValues: MultiStepContextValues = {
  currentStep: 0,
  totalOfSteps: 0,
  setCurrentStep: useState,
  setTotalOfSteps: useState,
};

const MultiStepIndicatorContext = createContext(
  multiStepIndicatorInitialValues
);

export const MultiStepIndicatorProvider = ({ children }: PropsWithChildren) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [totalOfSteps, setTotalOfSteps] = useState(0);

  return (
    <MultiStepIndicatorContext.Provider
      value={{
        currentStep,
        totalOfSteps,
        setCurrentStep,
        setTotalOfSteps,
      }}
    >
      {children}
    </MultiStepIndicatorContext.Provider>
  );
};

export const useMultiStepIndicator = () =>
  useContext(MultiStepIndicatorContext);
